import AnimationHelper from 'modules/AnimationHelper';
import { parseHandleBars } from 'modules/HandlebarsTemplates';

const animateProfileMiddleArticleList = AnimationHelper(
  '#profileMiddleArticleList > .articleCard',
  {
    visiblePercent: 10
  }
);

// =========================

window.ProfilePage = {
  reset: changeProfileListType
};

let showPrivateMapIfZeroSharedMap = false;

const officialAccountGroupId = '5a092ee0b221246bdcc9c9e3';
const template = parseHandleBars($('#ProfileTemplate').html());
let account_id = '';
let lifeMap = {};

let skip = 0;
const limit = 10;

const mapListTemplate = parseHandleBars($('#StoreMapCardTemplate').html());
let ajaxObj;

const pmal = $('#profileMiddleArticleList');
const pmpl = $('#profileMiddlePhotoList');
const loading = $('#profileMiddleListLoading');

let currentListType = 'mySharedMap';

$(document).ready(() => {
  window.APIGetAllUserData({
    always() {
      const urlData = window.historyObj.getUrlData();
      // check type is already selected
      let type =
        urlData &&
        urlData.searchDic &&
        urlData.searchDic.type &&
        urlData.searchDic.type;
      account_id =
        urlData.searchDic.profile ||
        (Gdata.Profile.ori && Gdata.Profile.ori._id);

      if (
        account_id &&
        Gdata.Profile.ori &&
        Gdata.Profile.ori._id &&
        account_id === Gdata.Profile.ori._id
      ) {
        // show private map tab
        $('.changeProfileListTypemyPrivateMap').show();
        showPrivateMapIfZeroSharedMap = true;
      } else {
        type = type === 'myPrivateMap' ? null : type;
      }

      initializeProfile();

      changeProfileListType(type);
    }
  });

  window.APIGetMyMaps({
    always() {
      lifeMap =
        Gdata.MyMaps.ori &&
        Gdata.MyMaps.ori.find(map => {
          return map.is_lifemap === '1';
        });
    }
  });
});

$(document).on('click', '.changeProfileListType', e => {
  const type = $(e.currentTarget).data('type');

  changeProfileListType(type);

  const obj = window.historyObj.getUrlData({
    parseQuery: true,
    setQuery: {
      type
    }
  });
  window.historyObj.pushHistoryState(obj.url);
});

function initializeProfile() {
  new Promise((resolve, reject) => {
    if (!account_id) {
      return reject();
    }

    const data = {
      locale: window.hlocale
    };
    if (Cookies.get(CookieSession)) {
      data.session = Cookies.get(CookieSession);
    }
    data._ids = [account_id];

    window.APIModule.callAPI({
      name: 'AccountReadPublic',
      data,
      success(result) {
        if (result.success && result.response[0]) {
          const account = result.response[0];

          if (account.groups) {
            account.groups.forEach(group => {
              if (group === officialAccountGroupId) {
                account.is_official = true;
              }
            });
          }

          if (account.homepage) {
            account.homepage_link = account.homepage;
            if (account.homepage_link.indexOf('//') < 0) {
              account.homepage_link = `https://${account.homepage_link}`;
            }
          }

          $('#ProfileTemplateContainer').html(template(account));

          if (window.translateCollection) {
            window.translateCollection([account], 'account');
          }
        } else {
          reject();
        }
      }
    });
  }).catch(() => {
    window.location.href = '/';
  });
}

function changeProfileListType(type) {
  currentListType = type || currentListType || 'timeline';

  $('.changeProfileListType').removeClass('active');
  $(`.changeProfileListType${currentListType}`).addClass('active');

  if (ajaxObj && ajaxObj.ajax) {
    ajaxObj.ajax.abort();
  }
  skip = 0;
  Gdata.CurrentDialies.ori = [];
  Gdata.CurrentDialies.dic = {};
  Gdata.CurrentDialies.loaded = 0;
  Gdata.CurrentPhotos.ori = [];
  Gdata.CurrentPhotos.photoSwipeItems = [];

  pmal.html('');
  pmpl.html('');
  loadControl.isRendering = false;

  window.photoWallLoadingInstanceCount = 0;

  loading.show();

  if (currentListType === 'timeline' || currentListType === 'photo') {
    loadControl.callback = doTimelineOrPhoto;
    doTimelineOrPhoto();
  } else {
    loadControl.callback = null;
    getMaps();
  }
}

function doTimelineOrPhoto() {
  if (loadControl.isRendering || Gdata.CurrentDialies.loaded === 2) {
    return;
  }

  loadControl.isRendering = true;

  ajaxObj = window.API({
    apiName: 'DialyRead',
    rest: {
      data: {
        // session: Cookies.get(CookieSession),
        account_id,
        skip,
        limit,
        special_contents: AS.mapSpecialContents,
        locale: window.hlocale
      }
    },
    callback: {
      always(responseObj) {
        if (responseObj.success) {
          skip += responseObj.response.length;

          if (responseObj.response.length < limit) {
            Gdata.CurrentDialies.loaded = 2;
            loading.hide();
          }

          Gdata.CurrentDialies.ori = _.concat(
            Gdata.CurrentDialies.ori,
            responseObj.response
          );
          Gdata.CurrentDialies.dic = _.keyBy(Gdata.CurrentDialies.ori, '_id');
          window.ObjsToUpdate.dialy.CurrentDialies = Gdata.CurrentDialies;

          const spotList = [];
          const mapList = [];

          responseObj.response.forEach(dialy => {
            if (!dialy.map) {
              return;
            }

            // api returns deleted_flag = 1, must check
            if (dialy.map.delete_flag === 1) {
              dialy.map = lifeMap;
            }

            // check looking at other profile
            if (Gdata.Profile.ori && Gdata.Profile.ori._id !== account_id) {
              // is other profile
              if (!MapClass.checkShared(dialy.map.share_id)) {
                // don't show private
                console.log('not shared');
                return;
              }
            }

            dialy.share_url = window.parseShareUrl(dialy);
            window.parseDialySpotImages(dialy);

            dialy.reply_count = dialy.reply_count || {};
            dialy.reply_count.good = dialy.reply_count.good || 0;
            try {
              dialy.description = decodeURIComponent(dialy.description || '');
            } catch (e) {
              console.log(e);
            }

            //for photo wall
            _.forEach(dialy.images, image_id => {
              const photo = {
                image_id,
                dialy,
                index: Gdata.CurrentPhotos.ori.length
              };
              Gdata.CurrentPhotos.ori.push(photo);
              Gdata.CurrentPhotos.photoSwipeItems.push(
                window.parsePhotoSwiperItem(image_id, dialy)
              );

              if (currentListType === 'photo') {
                if (window.photoCardTemplate) {
                  pmpl.append(window.photoCardTemplate(photo));
                }
              }
            });

            if (currentListType === 'timeline') {
              if (
                window.dialyTemplate &&
                pmal.children(`.articleCard${dialy._id}`).length <= 0
              ) {
                pmal.append(window.dialyTemplate(dialy));
                window.initializeComments(dialy._id, 'dialy');
              }
            }

            spotList.push(dialy.spot);
            mapList.push(dialy.map);
          });

          if (window.translateCollection) {
            window.translateCollection(responseObj.response, 'dialy');
            window.translateCollection(spotList, 'spot');
            window.translateCollection(mapList, 'map');
          }

          if (currentListType === 'photo') {
            window.photoCardLoadImage();
            window.photoCardLoadImage();
            window.photoCardLoadImage();

            if (
              Gdata.CurrentDialies.loaded === 2 &&
              Gdata.CurrentPhotos.ori.length === 0
            ) {
              if (window.noItemTemplate && $('.noItemCard').length === 0) {
                pmal.append(
                  window.noItemTemplate({
                    class: 'noItemCard',
                    wallType: 'wtPhoto'
                  })
                );
              }
            }
          } else {
            window.trunk8FoldText();

            if (
              Gdata.CurrentDialies.loaded === 2 &&
              Gdata.CurrentDialies.ori.length === 0
            ) {
              if (window.noItemTemplate && $('.noItemCard').length === 0) {
                pmal.append(
                  window.noItemTemplate({
                    class: 'noItemCard',
                    wallType: 'wtTimeline'
                  })
                );
              }
            }
          }
        }

        loadControl.isRendering = false;

        wallScrollCheck();

        animateProfileMiddleArticleList();
      }
    }
  });
}

function getMaps() {
  const locale =
    currentListType === 'myPrivateMap' ? undefined : window.hlocale;

  window.APIModule.callAPI({
    name: 'MapList',
    data: {
      session: Cookies.get(CookieSession),
      account_id,
      locale
    },
    success(result) {
      let mapList = [];

      if (result.success) {
        mapList = result.response.filter(map => {
          if (map.is_lifemap) {
            map.title = window.resolveLang('ライフマップ');
          }

          // check official
          const profile = Gdata.Profile.ori;
          if (
            profile &&
            profile.groups &&
            window.CONFIG_ARR.account.checkOfficial(profile.groups)
          ) {
            if (map.is_lifemap) {
              return false;
            }
          }

          if (map.is_wantmap) {
            return false;
          }

          if (map.categories && map.categories[0]) {
            map.cat = map.categories[0].lcategory;
          }

          // Authentication check
          // not need but just to be sure not to show private maps to other users
          if (map.session_account_id !== map.account_id) {
            // other users' maps
            if (!MapClass.checkShared(map.share_id)) {
              return false;
            }
          }
          // Authentication check

          if (currentListType === 'follow') {
            return !!map.followmap_id;
          } else if (currentListType === 'myPrivateMap') {
            return !MapClass.checkShared(map.share_id) && !map.followmap_id;
          } else if (currentListType === 'mySharedMap') {
            return MapClass.checkShared(map.share_id) && !map.followmap_id;
          }

          return false;
        });

        mapList.forEach(map => {
          pmal.append(mapListTemplate(map));
        });

        if (currentListType !== 'myPrivateMap') {
          if (window.translateCollection) {
            window.translateCollection(mapList, 'map');
          }
        }
      }

      if (showPrivateMapIfZeroSharedMap && !mapList.length) {
        showPrivateMapIfZeroSharedMap = false;
        changeProfileListType('myPrivateMap');
        return;
      }
      showPrivateMapIfZeroSharedMap = false;

      loading.hide();

      if (
        mapList.length === 0 &&
        window.noItemTemplate &&
        $('.noItemCard').length === 0
      ) {
        if (currentListType === 'follow') {
          return pmal.append(
            window.noItemTemplate({
              class: 'noItemCard',
              wallType: 'wtFollow'
            })
          );
        } else if (currentListType === 'myPrivateMap') {
          pmal.append(
            window.noItemTemplate({
              class: 'noItemCard',
              wallType: 'wtPrivateMap'
            })
          );
        } else if (currentListType === 'mySharedMap') {
          pmal.append(
            window.noItemTemplate({
              class: 'noItemCard',
              wallType: 'wtSharedMap'
            })
          );
        }
      }

      if (Gdata.Profile.ori && Gdata.Profile.ori._id === account_id) {
        pmal.removeClass('otherProfile');
      } else {
        pmal.addClass('otherProfile');
      }
    }
  });
}

// Load More on scrolled to bottom
let loadControl = {
  difference: 1900,
  isRendering: false,
  callback: undefined
};
$(window).scroll(() => {
  wallScrollCheck();
});

function wallScrollCheck() {
  const scrollBottom = $(window).scrollTop() + $(window).height();
  const docHeight = $(document).height();
  if (
    docHeight - scrollBottom <= loadControl.difference &&
    loadControl.callback
  ) {
    loadControl.callback();
  }
}
